export * from './tipo-beneficiario.pipe';
